
import { useState } from 'react';

const faqs = [
  {
    question: "How do I get a free estimate for my project?",
    answer: "Simply call us at 780-517-8242, email Info@sierrakustoms.ca, or fill out the quote form on this page. We typically respond within 24 hours and can schedule an on-site assessment at your convenience."
  },
  {
    question: "What areas do you serve?",
    answer: "We proudly serve Edmonton, Edson, Hinton, Whitecourt, and Spruce Grove in Alberta, Canada, as well as select locations in Mexico. Contact us to confirm service availability in your area."
  },
  {
    question: "Are you licensed and insured?",
    answer: "Yes, Sierra Kustom Inc. is fully licensed and insured. We carry comprehensive liability insurance and workers\\' compensation coverage to protect both our team and your property."
  },
  {
    question: "How long does a typical project take?",
    answer: "Project timelines vary based on scope and complexity. A standard trim or door installation may take 1-3 days, flooring projects 2-5 days, and custom deck builds 1-3 weeks. We provide detailed timelines during your free consultation."
  },
  {
    question: "Do you offer warranties on your work?",
    answer: "Absolutely. We stand behind our craftsmanship with warranties on all installation services. Specific warranty terms vary by service type and are discussed during the quoting process."
  },
  {
    question: "Can I schedule cleaning services on a recurring basis?",
    answer: "Yes! We offer flexible scheduling for both residential and office cleaning — weekly, bi-weekly, monthly, or custom schedules. We work around your availability to minimize disruption."
  }
];

export default function ServicesFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-block mb-4 px-5 py-2 bg-amber-100 rounded-full">
            <span className="text-amber-700 font-semibold text-sm tracking-wide uppercase">FAQ</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4 tracking-tight">
            Common Questions
          </h2>
          <p className="text-gray-600 text-base">
            Everything you need to know about our services
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'border-amber-200 bg-amber-50/50 shadow-sm' : 'border-gray-200 bg-white'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 cursor-pointer text-left"
              >
                <span className={`font-semibold text-sm pr-4 ${openIndex === index ? 'text-amber-700' : 'text-gray-900'}`}>
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                  openIndex === index ? 'bg-amber-500 rotate-180' : 'bg-gray-100'
                }`}>
                  <i className={`ri-arrow-down-s-line text-lg ${openIndex === index ? 'text-white' : 'text-gray-500'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-5 text-gray-600 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
